const SmallStar = ({ color = "#0E9F6E" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <g clipPath="url(#clip0_5817_7261)">
      <path
        d="M7.74588 0.461426C7.60901 0.179443 7.31977 0 7.00213 0C6.68449 0 6.39783 0.179443 6.25838 0.461426L4.59786 3.85291L0.889435 4.39636C0.579539 4.44251 0.321293 4.65784 0.225742 4.95264C0.13019 5.24744 0.207664 5.573 0.429756 5.79089L3.12069 8.43384L2.4854 12.1688C2.43375 12.4764 2.56287 12.7892 2.81854 12.9712C3.0742 13.1532 3.4125 13.1763 3.69141 13.0302L7.00471 11.2742L10.318 13.0302C10.5969 13.1763 10.9352 13.1558 11.1909 12.9712C11.4466 12.7866 11.5757 12.4764 11.524 12.1688L10.8862 8.43384L13.5771 5.79089C13.7992 5.573 13.8792 5.24744 13.7811 4.95264C13.683 4.65784 13.4273 4.44251 13.1174 4.39636L9.40641 3.85291L7.74588 0.461426Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_5817_7261">
        <rect width="14.875" height="13.125" fill="white" transform="translate(-0.4375)" />
      </clipPath>
    </defs>
  </svg>
);

export default SmallStar;
